import { useMemo } from 'react';
import { getModifiedFieldValues } from '@lp/features/RoutePlanner/components/LogisticsChangeLog/utils';
import { AccommodationLegModifiedLog, GroundTripReassignedLog, ModifiedLogisticsChangeLog } from '@/api/apis/route';
import { ModifiedFieldValues } from './ModifiedFieldValues';

type ModifiedChangeLogProps = {
  log: ModifiedLogisticsChangeLog | AccommodationLegModifiedLog | GroundTripReassignedLog;
};

export const ModifiedChangeLog = ({ log }: ModifiedChangeLogProps) => {
  const modifiedLogs = useMemo(() => {
    return getModifiedFieldValues(log);
  }, [log]);

  if (!modifiedLogs.length) {
    return null;
  }

  return (
    <div className="flex flex-col p-3 gap-3 rounded bg-base-90">
      {modifiedLogs.map((modifiedLog) => (
        <ModifiedFieldValues key={modifiedLog.id} {...modifiedLog} />
      ))}
    </div>
  );
};
